import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { NgxMaskDirective } from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { InputWrapperComponent } from '../../../../shared/components/input-wrapper/input-wrapper.component';
import { MultiselectDropdownComponent } from '../../../../shared/components/multiselect-dropdown/multiselect-dropdown.component';
import {
  COUNTRY_CODE,
  COUNTRY_CODE_DROPDOWN_CONFIG,
} from '../../../../shared/constants/impact-partners.constant';
import { MediaPartnerModel } from '../../../../shared/models/impact-partners.model';
import { DropDownOption } from '../../../../shared/models/multiselect-dropdown.model';
import { ImpactPartnersService } from '../../../../shared/services/impact-partners.service';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-add-edit-partners',
  standalone: true,
  imports: [
    ButtonComponent,
    ButtonLoaderComponent,
    SharedModule,
    InputWrapperComponent,
    MultiselectDropdownComponent,
    NgxMaskDirective,
  ],
  templateUrl: './add-edit-partners.component.html',
  styleUrl: './add-edit-partners.component.scss',
})
export class AddEditPartnersComponent implements OnInit {
  @Input() editPartner!: MediaPartnerModel | null;
  @Output() onClose: EventEmitter<void> = new EventEmitter();
  @Output() onUpdate: EventEmitter<void> = new EventEmitter();
  impactPartnerForm: FormGroup = this.fb.group({
    mediaPartnerId: ['', [Validators.required]],
    phone: ['', [Validators.required]],
    countryCode: ['', [Validators.required]],
    name: ['', [Validators.required]],
  });
  isLoading = false;
  countryCodeConfig = COUNTRY_CODE_DROPDOWN_CONFIG;
  countryCodesOptions: DropDownOption[] = COUNTRY_CODE;

  constructor(
    private readonly fb: FormBuilder,
    private readonly impactPartnersService: ImpactPartnersService,
    private readonly toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.setInitialFormValues();
  }

  onSubmit() {
    if (!this.impactPartnerForm.valid) {
      this.impactPartnerForm.markAllAsTouched();
      return;
    }
    const { mediaPartnerId, phone, countryCode, name } =
      this.impactPartnerForm.value;

    const payload = {
      mediaPartnerId: mediaPartnerId,
      phone: `+${countryCode.value}${phone}`,
      name: name,
    };
    this.isLoading = true;
    if (this.editPartner) {
      this.impactPartnersService
        .updateMediaPartner(this.editPartner?.id ?? '', payload)
        .subscribe({
          next: (data) => {
            this.toastr.success('Media Partner updated successfully!');
            this.onUpdate.emit();
            this.isLoading = false;
          },
          error: (error) => {
            this.toastr.error(
              error?.error?.message || error?.message || 'Something went wrong!'
            );
            this.isLoading = false;
          },
        });
    } else {
      this.impactPartnersService.addMediaPartner(payload).subscribe({
        next: (data) => {
          this.toastr.success('Media Partner added successfully!');
          this.onUpdate.emit();
          this.isLoading = false;
        },
        error: (error) => {
          this.toastr.error(
            error?.error?.message || error?.message || 'Something went wrong!'
          );
          this.isLoading = false;
        },
      });
    }
  }
  handleClose() {
    this.onClose.emit();
  }
  handleSearch(text: string) {
    if (text.length > 0) {
      this.countryCodesOptions = COUNTRY_CODE.filter((el) =>
        el.displayLabel?.toLowerCase()?.includes(text)
      );
    } else {
      this.countryCodesOptions = COUNTRY_CODE;
    }
  }

  setInitialFormValues() {
    if (this.editPartner) {
      const phone = this.editPartner.phone?.slice(
        this.editPartner?.phone?.length - 10
      );
      const countryCode = this.editPartner?.phone?.replace(phone ?? '', '');
      const countryCodeOption = COUNTRY_CODE.find(
        (code) => code.label === countryCode
      );
      this.impactPartnerForm.patchValue({
        mediaPartnerId: this.editPartner.mediaPartnerId,
        name: this.editPartner.name,
        phone: phone,
        countryCode: countryCodeOption ?? '',
      });
    }
  }
}
